import { Button, Form, Upload } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import { useUploadFileRule } from "../../../../../lib/hooks/useUploadFileRule";
import { useUploadFile } from "../../../../../lib/hooks/useUploadFile";
import { useCallback } from "react";

type UploadAttachmentProps = {
  setIsUploading: React.Dispatch<React.SetStateAction<boolean>>;
  setHasFile: React.Dispatch<React.SetStateAction<boolean>>;
};

export const UploadAttachment = ({
  setIsUploading,
  setHasFile,
}: UploadAttachmentProps) => {
  const { rule } = useUploadFileRule();

  const { upload } = useUploadFile(4, setIsUploading);

  const onFileChange = useCallback(
    (val: any) => setHasFile(val.fileList.length > 0),
    [setHasFile]
  );

  return (
    <Form.Item
      name="attachment"
      className="attachment-form-item mb-0"
      valuePropName="fileList"
      getValueFromEvent={(e) => e.fileList}
      rules={rule}
    >
      <Upload maxCount={1} customRequest={upload} onChange={onFileChange}>
        <Button
          shape="circle"
          icon={<PaperClipOutlined />}
          className="mt-4"
          size="large"
        />
      </Upload>
    </Form.Item>
  );
};
